<template>
    <v-dialog v-model="dialog" width="fit-content" @click:outside="close">
        <v-card min-width="300">
            <v-card-title class="text">{{ title }}</v-card-title>
            <v-card-text class="text">{{ content }}</v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                    color="primary darken-1"
                    text
                    :tabindex="0"
                    :loading="loading"
                    @click="submit"
                    >確定</v-btn
                >
                <v-btn
                    color="grey darken-3"
                    :tabindex="0"
                    text
                    @click="close"
                    :disabled="loading"
                    >取消</v-btn
                >
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    props: {
        title: {
            default: '你確定要刪除嗎?',
            type: String,
        },
        content: {
            default: '此操作無法還原',
            type: String,
        },
        handleSubmit: Function,
    },
    data: () => ({
        dialog: false,
        loading: false,
        payload: null,
    }),
    methods: {
        show(payload) {
            this.dialog = true;
            this.payload = payload;
        },
        close() {
            this.dialog = false;
        },
        async submit() {
            this.loading = true;
            try {
                await this.handleSubmit(this.payload);
                this.close();
            } catch (e) {
                this.$showApiError(e);
            } finally {
                this.loading = false;
            }
        },
    },
};
</script>

<style>
</style>
